import * as React from "react";
import { styled } from "@mui/material";
import { DemoLayoutTitle } from "./demoLanding";
import email_icon from "../assets/email_icon.svg";
import password_icon from "../assets/password_icon.svg";

//region [[ Styles ]]

const UserAuthenticationWrapperView = styled("div")({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "flex-start",

  "& form": {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  "& .speciality-input": {
    width: "100%",
    margin: "7px 0",
  },
  "& .patient-MuiFormControl-marginNormal, & .MuiFormControl-marginNormal": {
    margin: "7px 0",
  },
  "& .kahun-condensed": {
    fontFamily: "inherit",
  },
  "& div[class*=' UserLoginContainer']": {
    borderRadius: "9.7px",
    boxShadow: " 0px 8.571428298950195px 20.816326141357422px 0px #0000000D",
    padding: "25px",
  },
  "& .patient-MuiInputLabel-outlined, & .MuiInputLabel-outlined": {
    paddingLeft: "25px",
    transition: "all 0.2s ease-out",
  },
  "& .patient-MuiInputLabel-outlined.MuiInputLabel-shrink, & .MuiInputLabel-outlined.MuiInputLabel-shrink": {
    paddingLeft: "6px",
  },
  "& .email-input fieldset": {
    backgroundImage: `url(${email_icon})`,
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "scroll",
    backgroundSize: "16px 18px",
    backgroundPosition: "15px 50%",
  },
  "& input": {
    padding: "18.5px 45px",
  },
  "& .password-input fieldset": {
    backgroundImage: `url(${password_icon})`,
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "scroll",
    backgroundSize: "16px 18px",
    backgroundPosition: "15px 50%",
  },
  "& .patient-MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #AAB0B7",
    borderRadius: "8px",
  },
  "& .patient-MuiFormLabel-root.Mui-focused, .MuiFormLabel-root.Mui-focused": {
    color: "#5A52C3",
  },
  "& .patient-MuiOutlinedInput-root.Mui-focused .patient-MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#5A52C3",
  },
  "& .submit-button": {
    "&:not(.patient-Mui-disabled), &:not(.Mui-disabled)": {
      background: "#5A52C3",
      color: "white",
    },
    width: "fit-content",
    borderRadius: "20px",
    padding: "6px 38px",
    textTransform: "none",
    margin: "5px",
    marginBottom: "25px",
  },
  "& .navigation-link": {
    width: "100%",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "none",
  },
});

const Title = styled(DemoLayoutTitle)({
  textAlign: "center",
  width: "fit-content",
  marginBottom: "33px",
});

const SubTitle = styled("div")({
  fontWeight: 400,
  fontSize: "14px",
  marginBottom: "22px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface UserAuthenticationWrapperProps {
  subtitle: string;
  children: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const UserAuthenticationWrapper = ({
  ...props
}: UserAuthenticationWrapperProps) => {
  return (
    <UserAuthenticationWrapperView>
      <Title>Try it yourself</Title>
      <SubTitle>{props.subtitle}</SubTitle>
      {props.children}
    </UserAuthenticationWrapperView>
  );
};
